import h from 'virtual-dom/h'

export default class Renderer {
    constructor(settings) {
        this._settings = settings;
    }

    initialize(store) {
        this._store = store;
    }

    getRender() {
        return () => {
            return h('div', {
                className : this._settings.classNames.resizeToolClassName
            });
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/window-jquery-resize/src/renderers/renderer.js